// extracted by mini-css-extract-plugin
export var dataCell = "_mg-2";
export var dataRow = "_mg-0";
export var headerRow = "_mg-1";